export default "__VITE_ASSET__CrK9jf0I__"